import './recurrenceSettings.scss'
import { Dropdown } from 'ui_kit_qmd'
import moment from 'moment-timezone'
import { Calendar } from 'react-calendar'
// @ts-expect-error TS6133 -- MIGRATION: not approved, fix when encountered
import React, { memo, useCallback } from 'react'
import classnames from 'classnames'
import calendarIcon from '../../../../images/common/calendar.png'
import RadioButtonsGroup from '../../../../components/radio-buttons-group/RadioButtonsGroup'
import DaysOfWeekSelect from '../../../../components/days-of-week-select/DaysOfWeekSelect'
import { DATE_TIME_ISO_FORMAT } from '../../../../utils/dateUtils'

const availabilityPopUpDateDropdownContainerStyle = {
  width: 411,
  height: 350,
  marginTop: 8,
}
const dateDropDownContainerStyle = {
  width: 411,
  position: 'relative',
  top: '-12px',
}

const RecurrenceSettings = memo(
  ({
    // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
    setRepeatsSelectError,
    // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
    endDate,
    // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
    endDateDropDownCustomIconStyle,
    // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
    calendarTimeZone,
    // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
    clickedEndDateTime,
    // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
    onSetRepeatEndDateValue,
    // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
    repeatEndDate,
    // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
    repeatsSelectError,
    // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
    daysOfWeekRef,
    // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
    isOnSelected,
    // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
    repeatDays,
    // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
    setSelectedOption,
    // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
    selectedOption,
    // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
    height,
    // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
    setPrevSelectedDays,
    // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
    prevSelectedDays,
    // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
    onChangeButtonGroup,
  }) => {
    const isShowCalendarPopUpTopAligned = height < 1430
    const dropdownMinDate = moment(clickedEndDateTime?.dateTime)
      .parseZone()
      .tz(calendarTimeZone, true)
      .add(1, 'day')
      .format(DATE_TIME_ISO_FORMAT)

    const calendarMinDate = new Date(moment.tz(endDate.dateTime, calendarTimeZone).format('YYYY-MM-DD HH:mm'))
    const dropdownEndDate =
      repeatEndDate?.displayDate !== 'Invalid date' ?
        repeatEndDate?.displayDate
      : moment(endDate.displayDate).add(1, 'days')
    const dropdownMaxDate = moment().add(12, 'month').format(DATE_TIME_ISO_FORMAT)
    const dropdownValue = !isOnSelected ? '' : moment(dropdownEndDate).format('dddd MMM DD YYYY')

    const onChangeCalendarValue = useCallback(
      // @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
      (value) => onSetRepeatEndDateValue(value, 'repeatEndDate'),
      [onSetRepeatEndDateValue],
    )

    return (
      <div className='availability-datetimepicker-container'>
        <div className='availability-reccurence-settings-container'>
          <div className='availability-repeats-on-container'>
            <p className='availability-repeats-on-title'>
              Repeats on{' '}
              <span
                className={classnames('recurrence-settings-star-character-container', {
                  isError: repeatsSelectError,
                })}>
                *
              </span>
            </p>
            <DaysOfWeekSelect
              // @ts-expect-error TS2322 -- MIGRATION: not approved, fix when encountered
              calendarTimeZone={calendarTimeZone}
              setError={setRepeatsSelectError}
              error={repeatsSelectError}
              ref={daysOfWeekRef}
              repeatDays={repeatDays}
              prevSelectedDays={prevSelectedDays}
              setPrevSelectedDays={setPrevSelectedDays}
            />
          </div>
          <div className='availability-repeats-on-container'>
            <p className='availability-repeats-on-title'>Ends</p>
            <div className='availability-button-group-container'>
              <RadioButtonsGroup
                // @ts-expect-error TS2322 -- MIGRATION: not approved, fix when encountered
                className='availability-repeats-radio-buttons-group'
                setSelectedOption={setSelectedOption}
                onChangeButtonGroup={onChangeButtonGroup}
                optionsList={selectedOption}
              />
              <div className='availability-datetimepicker-box'>
                <Dropdown
                  isDateCase
                  isDisabled={!isOnSelected}
                  isShowStar
                  isCalendarOptions
                  isStateDropdown
                  showAbove={isShowCalendarPopUpTopAligned}
                  containerStyle={dateDropDownContainerStyle}
                  dropdownContainerStyle={availabilityPopUpDateDropdownContainerStyle}
                  value={dropdownValue}
                  calendarValue={dropdownEndDate}
                  setCalendarValue={onChangeCalendarValue}
                  dropId='Date*'
                  label='Date*'
                  maxDate={dropdownMaxDate}
                  minDate={dropdownMinDate}
                  customIcon={calendarIcon}
                  customIconStyles={endDateDropDownCustomIconStyle}
                  minCalendarDate={calendarMinDate}
                  Calendar={Calendar}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  },
)

export default RecurrenceSettings
